import { css } from '@emotion/react';
import { t } from 'i18n';
import { BOUND_SIDE } from 'shared';

import { LoadingIndicator } from '../../components';
import { theme } from '../theme';

const styles = {
  button: css`
    white-space: nowrap;
    @media (max-width: ${theme.breakpoints.tablet}) {
      width: 100%;
    }
  `,
};

type CartButtonBoundItem = { boundSide: BOUND_SIDE; selected: boolean; id?: string };

type Props = {
  boundItems: CartButtonBoundItem[];
  isLoadingPrice?: boolean;
  handleContinue: () => void;
};

export const CartButton = ({ boundItems, isLoadingPrice, handleContinue }: Props) => {
  const invalidBound = boundItems.find(boundItem => !boundItem.selected);

  let title = t('common:continue');
  if (invalidBound) {
    title = invalidBound.boundSide === BOUND_SIDE.Inbound ? t('common:selectInbound') : t('common:selectOutbound');
  }
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (!isLoadingPrice && !invalidBound) {
      return handleContinue();
    }

    if (invalidBound?.id) {
      scrollToElement(invalidBound.id);
    }
  };

  return (
    <button css={styles.button} onMouseDown={handleButtonClick} data-testid="cart continue button">
      {isLoadingPrice ? (
        <>
          {t('loadingPrice')} <LoadingIndicator />
        </>
      ) : (
        title
      )}
    </button>
  );
};

function scrollToElement(id: string) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
